export default "__VITE_ASSET__0cd83a77__"